import { cloneDeep, has, merge } from "lodash";
import type { ChatMessage } from "../chatMessage/chatMessage.entity";
import { formatRocketchatTimestamp } from "../utils/formatRocketchatTimestamp";

type RetrieveTargetsForReadUpdateParams = {
  messages: ChatMessage[];
  readerId: string;
  readMessageId: string;
};

export const retrieveTargetsForReadUpdate = ({
  messages,
  readerId,
  readMessageId,
}: RetrieveTargetsForReadUpdateParams) => {
  const updateTargets: ChatMessage[] = [];

  for (const message of messages) {
    const isReadByUser = has(message.seen, readerId);
    if (isReadByUser) {
      continue;
    }

    updateTargets.push(
      merge(cloneDeep(message), {
        seen: {
          [readerId]: formatRocketchatTimestamp(Date.now()),
        },
      }),
    );

    if (message.id === readMessageId) {
      break;
    }
  }

  return updateTargets;
};
